<template>
  <div class="mx-4 px-4">
    <v-row class="d-flex justify-between mt-2 mb-2">
      <v-col cols="11" md="11">
        <v-tabs v-model="tab" class="d-flex" grow>
          <v-tab @click="getVerifications('not_verified')">Pending</v-tab>
          <v-tab @click="getVerifications('verified')">Verified</v-tab>
        </v-tabs>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <v-row>
          <v-col cols="12">
            <v-sheet outlined>
              <v-data-table
                :headers="filteredHeaders"
                :search="search"
                :loading="loading"
                :items="profile_photo_verifications"
                fixed-header
                class="secondary row-height-50"
              >
                <template #[`item.action`]="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    color="accent"
                    @click="getImage(item)"
                  >
                    mdi-image
                  </v-icon>
                </template>
                <template #[`item.submitted_at`]="{ value }">
                  {{ formatDate(value) }}
                </template>
                <template #[`item.verified_at`]="{ value }">
                  {{ formatDate(value) }}
                </template>
              </v-data-table>
            </v-sheet>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          <v-col cols="12">
            <v-sheet outlined>
              <v-data-table
                :headers="filteredHeaders"
                :search="search"
                :loading="loading"
                :items="profile_photo_verifications"
                fixed-header
                class="secondary row-height-50"
              >
                <template #[`item.action`]="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    color="accent"
                    @click="getImage(item)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <template #[`item.submitted_at`]="{ value }">
                  {{ formatDate(value) }}
                </template>
                <template #[`item.verified_at`]="{ value }">
                  {{ formatDate(value) }}
                </template>
              </v-data-table>
            </v-sheet>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
    <formDialog v-if="dialog" :item="currentItem" @close="closeDialog()" />
  </div>
</template>

<script>
import formDialog from "@/views/profile_photo_approval.vue";
import searchBar from "@/components/searchBar.vue";
import { profilePhotoVerificationHeaders } from "@/constants/headers";
import { levels } from "@/constants/enum";
import ConfirmDialog from "@/components/confirm.vue";
export default {
  components: {
    formDialog,
    searchBar,
    ConfirmDialog,
  },
  data() {
    return {
      dialog: false,
      currentItem: {},
      profile_photo_verifications: [],
      search: "",
      headers: profilePhotoVerificationHeaders,
      levels: levels,
      filteredHeaders: [],
      profilePreview: null,
      loading: false,
      tab: 0,
      activeTab: 0,
    };
  },
  watch: {},
  computed: {},
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Image Verification" }]);
    this.initialise();
  },
  methods: {
    initialise() {
      if (this.tab === 0) {
        this.getVerifications("not_verified");
      } else if (this.tab === 1) {
        this.getVerifications("verified");
      }
    },
    async getVerifications(status) {
      this.filteredHeaders = [...this.headers];

      if (status == "not_verified") {
        this.filteredHeaders = this.filteredHeaders.filter((h) => h.value !== "verified_at");
      }
      this.profile_photo_verifications = [];
      this.loading = true;
      await this.$axios
        .get(`profile_photo_verifications?status=${status}`)
        .then((res) => {
          this.profile_photo_verifications = res.data.data.sort(
            (a, b) => b.id - a.id
          );
          this.loading = false;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },

    async getImage(item) {
      this.currentItem = { ...item };
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      // this.initialise();
    },
    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${String(date.getFullYear()).padStart(4, "0")} ${String(
        date.getHours()
      ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
    },
  },
};
</script>

<style>
.v-data-table::v-deep td {
  font-size: 12px !important;
  padding-right: 0px !important;
}

.v-data-table::v-deep th {
  font-size: 12px !important;
  padding-right: 0px !important;
}
</style>
